import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestReservation = fp.get('guest.reservation');

export const getAll = createSelector(getGuestReservation, fp.get('all'));

export const getAllValues = createSelector(getAll, fp.values);

export const getFetching = createSelector(
  getGuestReservation,
  fp.get('fetching')
);
export const getFetched = createSelector(
  getGuestReservation,
  fp.get('fetched')
);
export const getFetchingError = createSelector(
  getGuestReservation,
  fp.get('fetchingError')
);
export const getOrder = createSelector(getGuestReservation, fp.get('order'));
